<template>
    <div>
        <BaseTable
            :naked="true"
            title="Monedero"
            subtitle="Saldo y historial de transacciones"
            :columns="columns"
            :data="transacciones"
            :loading="loading"
            :row-key="'id'"
            empty-text="No hay transacciones en el monedero"
            :default-col-width="defaultColWidth"
        >
            <template #header-action>
                <Button
                    v-if="abonado.user_id"
                    @click="$emit('add-monedero')"
                    class="tw:text-xs tw:sm:text-sm"
                >
                    Añadir al monedero
                </Button>
            </template>
            <template #cell-descripcion="{ row }">
                <span class="tw:text-sm tw:text-gray-800">{{ row.descripcion }}</span>
            </template>
            <template #cell-importe="{ row }">
                <div class="tw:text-sm">{{ row.importe | formatear_precio }}</div>
            </template>
        </BaseTable>

        <TablePagination
            v-if="totalPages > 1"
            :value="currentPage"
            :total="totalRows"
            :per-page="perPage"
            @input="currentPage = $event"
        />
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, watch } from 'vue'
    import store from '@/store'
    import { config } from '@/config.js'
    import Button from '@/modules/admin/ui/Button.vue'
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue'
    import TablePagination from '@/modules/admin/ui/table/TablePagination.vue'

    const props = defineProps({
        abonado: {
            type: Object,
            required: true
        },
        defaultColWidth: {
            type: String,
            default: '120px'
        }
    })

    defineEmits(['add-monedero'])

    const transacciones = ref([])
    const total = ref(0)
    const loading = ref(false)
    const currentPage = ref(1)
    const perPage = ref(10)
    const totalRows = ref(0)

    const totalPages = computed(() => Math.ceil(totalRows.value / perPage.value))

    const columns = [
        { key: 'descripcion', label: 'Descripción' },
        { key: 'importe', label: 'Importe' }
    ]

    async function getMonedero() {
        loading.value = true
        const params = {
            abonado_id: props.abonado.id,
            filters: {
                page: currentPage.value
            }
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.abonados.monedero'),
                params
            )
            if (res.data && !res.data.error) {
                transacciones.value = res.data.data || []
                total.value = res.data.total || 0
                totalRows.value = res.data.meta?.total || 0
            }
        } catch (error) {
            console.error('Error fetching monedero:', error)
        } finally {
            loading.value = false
        }
    }

    onMounted(() => {
        getMonedero()
    })

    watch(() => currentPage.value, () => {
        getMonedero()
    })
</script>
